import React from 'react'
import { Box } from '@mui/material'
import { StandardRetriever } from './StandardRetriever'
import { Standard } from 'shared/types'

export function Test() {
  const [currentStandardIds, setCurrentStandardIds] = React.useState([
    517943, 55, 234, 76868,
  ])
  function onStandardSelect({ standardId }: Standard) {
    setCurrentStandardIds((prev) => [...prev, standardId])
  }

  function onStandardDelete({ standardId }: Standard) {
    setCurrentStandardIds((prev) => prev.filter((sid) => sid !== standardId))
  }
  return (
    <Box>
      <Box>Standards</Box>
      <Box>
        <StandardRetriever
          currentStandardIds={currentStandardIds}
          onStandardSelect={onStandardSelect}
          onStandardDelete={onStandardDelete}
        />
      </Box>
    </Box>
  )
}
